import { Controller } from "@hotwired/stimulus";
import "rhino-editor";
import "rhino-editor/exports/styles/trix.css";

// Connects to data-controller="rich-text-editor"
// Formatting-only rich text for admin forms: no attachments, no file drop/paste.
export default class extends Controller {
  static targets = ["editor"];

  initialize() {
    this.beforeInitialize = this.beforeInitialize.bind(this);
    this.rejectFile = this.rejectFile.bind(this);
  }

  connect() {
    document.addEventListener("rhino-before-initialize", this.beforeInitialize);
    this.editorTarget.addEventListener("rhino-file-accept", this.rejectFile);
  }

  disconnect() {
    document.removeEventListener("rhino-before-initialize", this.beforeInitialize);
    this.editorTarget.removeEventListener("rhino-file-accept", this.rejectFile);
  }

  beforeInitialize(event) {
    if (event.target !== this.editorTarget) return;

    this.editorTarget.starterKitOptions = {
      ...this.editorTarget.starterKitOptions,
      rhinoAttachment: false,
      rhinoGallery: false,
      rhinoFigcaption: false,
    };
  }

  rejectFile(event) {
    event.preventDefault();
  }
}
